import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingTextField: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16 1H0v14h16zM3 6V4h5v2H6.5v4H8v2H3v-2h1.5V6z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingTextField
